import * as appSyncClient from './realtime/appsync-client';

/**
 * Transport for the web channel.
 *
 * Bot replies are delivered over AppSync (the backend's web publisher posts a
 * `sendBotMessage` mutation), and user turns go out over the matching
 * `sendUserMessage` mutation. Kept behind this module so another transport can
 * be swapped in the way the web-plugin does.
 *
 * `?mock=1` substitutes an in-browser stub so the UI can be run without a
 * backend. The check below is against the literal `process.env.NODE_ENV`, which
 * the bundler replaces at build time - so a production build folds this to
 * `false` and drops the mock module from the output entirely, rather than
 * merely refusing to activate it at runtime.
 */
function resolveClient() {
  if (process.env.NODE_ENV !== 'production') {
    try {
      if (new URLSearchParams(window.location.search).get('mock') === '1') {
        // Required lazily so the dependency exists only on the dev path.
        return require('./realtime/mock-client');
      }
    } catch (e) {
      /* fall through to the real transport */
    }
  }
  return appSyncClient;
}

const client = resolveClient();

export const config = client.config;

export async function sendUserMessage(authToken, appId, sessionId, data) {
  return client.sendUserMessage(authToken, appId, sessionId, data);
}

export function subscribeBotMessage(authToken, appId, sessionId, next, error) {
  return client.subscribeBotMessage(authToken, appId, sessionId, next, error);
}
